import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrerenderReady from './PrerenderReady';
import { useLang } from '../contexts/LangContext';
import PublicToggleBar from './PublicToggleBar';

// 09.08: patrz identyczny komentarz w PrivacyPage.jsx - kolorystyka zdublowana (nie importowana),
// zeby nie dzielic namespace'u klas z landing page ani z .ga-root apki.
// 11.08: ciemny motyw dodany do tego samego wbudowanego <style> (patrz CennikPage.jsx dla pelnego
// kontekstu wzorca) - .legalp nie deklaruje --red/--red-soft/--panelA/--panelB, wiec ten blok ich
// tez nie emituje.
const LEGAL_TOKENS = `
.legalp{
  --paper:#E7E8E3; --paper-raised:#F8F9F6; --panel2:#DEE1DA; --ink:#1B2124; --ink-soft:#5C6569;
  --line:#C6CAC2; --line-soft:#D9DCD5;
  --accent:#1E7A46; --accent-ink:#FFFFFF; --accent-soft:#DCEEE2;
  --amber:#9C6A16; --amber-soft:#F3E4C8;
  --shadow:0 1px 2px rgba(20,30,25,.05), 0 8px 20px -12px rgba(20,30,25,.14);
}
[data-theme='dark'] .legalp{
  --paper:#15181A; --paper-raised:#1E2225; --panel2:#262B27; --ink:#E9EAE4; --ink-soft:#8B948F;
  --line:#33383A; --line-soft:#282C2E;
  --accent:#3CB878; --accent-ink:#0B1712; --accent-soft:#1B2E22;
  --amber:#D79A3C; --amber-soft:#332A18;
  --shadow:0 1px 2px rgba(0,0,0,.4), 0 10px 24px -12px rgba(0,0,0,.55);
}
`;

const UPDATED = '2026-08-09';

const SECTIONS = [
  {
    id: 'ogolne',
    title: '1. Postanowienia ogólne',
    content: `1.1 Niniejszy Regulamin określa zasady korzystania z serwisu internetowego Gap Assessment by MQS dostępnego pod adresem gapassessment.pl ("Serwis").

1.2 Operatorem Serwisu jest MQS MARCIN RABIASZ (NIP: 8971742369, REGON: 540955465, ul. Hiacyntów 5, 41-600 Świętochłowice, woj. śląskie), prowadzący działalność gospodarczą na podstawie wpisu do CEIDG (dalej: "Operator"), dostępny pod adresem e-mail: kontakt@mqs.com.pl.

1.3 Korzystanie z Serwisu oznacza akceptację niniejszego Regulaminu. Jeśli nie zgadzasz się z jego treścią, prosimy o zaprzestanie korzystania z Serwisu.

1.4 Regulamin jest dostępny pod adresem gapassessment.pl/regulamin w sposób umożliwiający jego pobranie, utrwalenie i wydrukowanie.`,
  },
  {
    id: 'uslugi',
    title: '2. Opis usług',
    content: `2.1 Gap Assessment by MQS jest narzędziem wspomagającym pracę konsultantów i audytorów ISO zarządzających portfelem klientów, przy użyciu sztucznej inteligencji. Serwis oferuje w szczególności:

- **Gap Audit** - analiza dokumentu klienta względem wybranej normy lub regulacji (m.in. ISO 9001, 14001, 45001, 27001, 22301, IATF 16949, VDA 6.3, ISO/IEC 42001, AQAP 2110/2210/2131, NIS2/UKSC 2026, GDP) z oceną procentową zgodności i listą konkretnych ustaleń
- **Propozycje poprawek AI** - AI proponuje konkretną treść poprawki dla każdego ustalenia; poprawka trafia wprost do pliku .docx po akceptacji użytkownika (pojedynczo lub w trybie wsadowym)
- **Bezpiecznik wyniku** - ostrzeżenie przed zaakceptowaniem poprawki, która obniżyłaby wcześniej osiągnięty wynik zgodności, z możliwością cofnięcia zmiany
- **Portfel klientów** - jeden portal do zarządzania wieloma odrębnymi przestrzeniami klientów, każda z własną historią analiz i dokumentów
- **Zespół i role** - zapraszanie współpracowników z rolą Właściciela, Audytora lub Zatwierdzającego, z opcjonalnym zawężeniem dostępu do jednej przestrzeni klienta
- **Publiczny link do raportu** - bezpieczny, ograniczony czasowo link umożliwiający udostępnienie zatwierdzonego wyniku analizy bez konieczności logowania
- **Biała etykieta (white-label)** - możliwość dostosowania wyglądu raportów do własnej marki konsultanta

2.2 **Ważne zastrzeżenie:** Serwis jest narzędziem wspomagającym, nie doradcą certyfikacyjnym. Wyniki analizy i proponowane poprawki:
- Stanowią punkt wyjścia do dalszej weryfikacji przez użytkownika
- Nie są substytutem konsultanta certyfikacyjnego ani audytora
- Wymagają oceny i dostosowania do specyfiki organizacji klienta
- Nie gwarantują uzyskania certyfikacji ISO ani zgodności z wymaganiami regulacyjnymi (UKSC 2026, NIS2 i in.)

2.3 Operator świadczy usługi 24/7, jednakże nie gwarantuje nieprzerwanej dostępności serwisu. Planowane przerwy techniczne będą komunikowane z wyprzedzeniem.`,
  },
  {
    id: 'konto',
    title: '3. Konto użytkownika',
    content: `3.1 Korzystanie z Serwisu wymaga założenia konta (jako właściciel nowej firmy) lub dołączenia do istniejącego konta na zaproszenie jego właściciela. Do rejestracji wymagany jest aktywny adres e-mail i hasło.

3.2 Użytkownik jest zobowiązany do:
- Podania prawdziwych danych przy rejestracji
- Zachowania poufności hasła do konta
- Niezwłocznego powiadomienia Operatora o nieautoryzowanym dostępie do konta

3.3 Konto nie może być odsprzedawane. Wspólna praca zespołu odbywa się przez mechanizm zaproszeń i ról opisany w pkt 2.1, nie przez współdzielenie danych logowania jednego użytkownika.

3.4 Domyślny okres przechowywania wyników Gap Audit i treści wgranych plików źródłowych wynosi **24 miesiące** od daty analizy. Właściciel konta może skrócić lub wydłużyć ten okres w Ustawieniach konta. Po upływie skonfigurowanego okresu dokumenty są automatycznie i trwale usuwane. Użytkownik może w każdej chwili samodzielnie usunąć dokumenty klienta w zakładce Historia, niezależnie od skonfigurowanego okresu.

3.5 Użytkownik może w każdej chwili usunąć konto kontaktując się z Operatorem pod adresem kontakt@mqs.com.pl. Usunięcie konta powoduje trwałe i natychmiastowe usunięcie wszystkich dokumentów oraz danych konta z bazy danych.

3.6 Operator zastrzega sobie prawo do zawieszenia lub usunięcia konta użytkownika, który narusza postanowienia Regulaminu.`,
  },
  {
    id: 'zasady',
    title: '4. Zasady korzystania z Serwisu',
    content: `4.1 Użytkownik zobowiązuje się do korzystania z Serwisu zgodnie z prawem, Regulaminem i dobrymi obyczajami.

4.2 Zabronione jest:
- Używanie Serwisu do celów niezgodnych z prawem
- Podejmowanie prób obchodzenia zabezpieczeń technicznych, w tym prób wpłynięcia na działanie modelu AI poprzez treść wgrywanych dokumentów (tzw. prompt injection)
- Automatyczne pobieranie danych (scraping) bez zgody Operatora
- Odsprzedawanie dostępu do konta lub udostępnianie go osobom spoza zaproszonego zespołu
- Używanie Serwisu w sposób nadmiernie obciążający infrastrukturę (np. masowe automatyczne uploady)
- Wgrywanie dokumentów zawierających dane, do których przetwarzania użytkownik nie posiada własnej podstawy prawnej (patrz Polityka Prywatności, sekcja 7.4)

4.3 Wgrywane dokumenty i podawane w Serwisie dane kontekstowe (nazwa klienta, branża) powinny być zgodne z prawdą i nie naruszać praw osób trzecich.

4.4 Wyniki analiz i wygenerowane poprawki są przeznaczone wyłącznie na użytek własny użytkownika lub jego klienta, którego dotyczą.`,
  },
  {
    id: 'wlasnosc',
    title: '5. Prawa własności intelektualnej',
    content: `5.1 **Prawa do Serwisu:** Wszelkie prawa do Serwisu, w tym interfejs, logo, kod źródłowy i grafiki, przysługują Operatorowi lub są używane na podstawie licencji. Zabronione jest kopiowanie i rozwijanie Serwisu.

5.2 **Prawa do wyników analizy i poprawek:** Wyniki analizy Gap Audit oraz treść poprawek zaakceptowanych przez użytkownika, powstałe na bazie dokumentu wgranego przez użytkownika, stanowią własność użytkownika. Operator nie nabywa żadnych praw do tych treści.

5.3 **Feedback i sugestie:** Ewentualne sugestie przesyłane przez użytkowników dotyczące rozwoju Serwisu mogą być swobodnie implementowane przez Operatora bez wzajemnych zobowiązań.`,
  },
  {
    id: 'platnosci',
    title: '6. Płatności i warunki współpracy',
    content: `6.1 Konto testowe (Trial) zakłada się samoobsługowo na stronie Serwisu, bez podawania danych karty płatniczej. Konto testowe obejmuje ograniczony zakres: do 3 klientów w portfelu, do 10 analiz Gap Audit oraz dostęp do wszystkich norm dostępnych w Serwisie, bez limitu czasowego korzystania.

6.2 Aktualny cennik planów płatnych (Starter, Growth, Enterprise) jest publicznie dostępny na stronie gapassessment.pl/cennik. Plany Starter i Growth aktywuje się samoobsługowo na stronie gapassessment.pl/cennik poprzez płatność online obsługiwaną przez PayU S.A. (ul. Grunwaldzka 186, 60-166 Poznań, KRS 0000274399) - krajową instytucję płatniczą nadzorowaną przez Komisję Nadzoru Finansowego. Operator nie przechowuje danych karty płatniczej ani danych logowania do bankowości - są one przetwarzane wyłącznie przez PayU.

6.3 Plan Enterprise wyceniany jest indywidualnie, w zależności od skali i wymagań integracyjnych klienta, po rozmowie z Operatorem - nie jest dostępny do samodzielnego zakupu online.

6.4 **Realizacja zamówienia.** Plany Starter i Growth aktywują się automatycznie i natychmiast po potwierdzeniu płatności przez PayU (zazwyczaj w ciągu kilku minut, w wyjątkowych przypadkach do 1 dnia roboczego przy opóźnieniu potwierdzenia płatności). Płatność jest jednorazowa i obejmuje okres 1 miesiąca - Serwis nie pobiera obecnie płatności cyklicznych automatycznie; przedłużenie planu na kolejny okres wymaga ponownej, samodzielnej płatności, o czym użytkownik jest informowany mailowo z 7-dniowym wyprzedzeniem przed wygaśnięciem opłaconego okresu. Brak przedłużenia skutkuje automatycznym przejściem konta na plan bezpłatny (Trial) z jego limitami, bez utraty danych portfela. Z uwagi na natychmiastową, automatyczną aktywację dostępu do usługi cyfrowej, użytkownik przed dokonaniem płatności wyraża odrębną, wyraźną zgodę na rozpoczęcie świadczenia usługi przed upływem 14-dniowego terminu odstąpienia od umowy, o którym mowa w Ustawie o prawach konsumenta - zgodnie z art. 38 pkt 13 tej ustawy, prawo odstąpienia nie przysługuje w takim przypadku.

6.5 **Zwroty i reklamacje.** Reklamacje dotyczące płatności lub działania planu płatnego należy zgłaszać na adres kontakt@mqs.com.pl, podając adres e-mail użyty do rejestracji konta oraz opis problemu. Reklamacje są rozpatrywane w terminie do 14 dni roboczych. W przypadku błędnie naliczonej lub podwójnie pobranej płatności Operator zwraca nienależną kwotę na rachunek, z którego dokonano płatności, w terminie do 14 dni od uznania reklamacji za zasadną.

6.6 W sprawach dotyczących oferty i płatności można kontaktować się pod adresem kontakt@mqs.com.pl.`,
  },
  {
    id: 'odpowiedzialnosc',
    title: '7. Ograniczenie odpowiedzialności',
    content: `7.1 Operator dokłada starań, aby wyniki analizy i proponowane przez AI poprawki były jak najdokładniejsze, jednakże:

**7.2 Operator nie ponosi odpowiedzialności za:**
- Wyniki audytu certyfikacyjnego klienta opartego na analizach lub poprawkach z Serwisu
- Decyzje biznesowe lub operacyjne podejmowane na podstawie wyników Serwisu
- Niezgodność wyników ze specyficznymi wymaganiami klientów użytkownika
- Zmiany w normach wprowadzone po dacie przeprowadzenia analizy
- Błędne lub niekompletne dokumenty wgrane przez użytkownika
- Przerwy w dostępie do Serwisu spowodowane czynnikami zewnętrznymi (awarie sieci, siła wyższa)

7.3 Odpowiedzialność Operatora jest ograniczona do wysokości opłat uiszczonych przez użytkownika w ciągu ostatnich 12 miesięcy.

7.4 Wyniki analizy i propozycje poprawek są pomocniczym narzędziem pracy - Serwis celowo ostrzega przed akceptacją zmiany obniżającej wynik zgodności (pkt 2.1), ale ostateczną ocenę i decyzję o wdrożeniu każdej poprawki podejmuje użytkownik.`,
  },
  {
    id: 'dane',
    title: '8. Przetwarzanie danych osobowych',
    content: `8.1 Zasady przetwarzania danych osobowych opisane są w Polityce Prywatności dostępnej pod adresem gapassessment.pl/polityka-prywatnosci.

8.2 Akceptując Regulamin użytkownik potwierdza, że zapoznał się z Polityką Prywatności.`,
  },
  {
    id: 'zmiany',
    title: '9. Zmiany Regulaminu',
    content: `9.1 Operator zastrzega sobie prawo do zmiany Regulaminu z ważnych przyczyn, takich jak:
- Zmiany w przepisach prawa mające wpływ na świadczone usługi
- Wprowadzenie nowych funkcji lub modelu płatności
- Zmiany organizacyjne lub techniczne

9.2 O zmianach Regulaminu użytkownik zostanie poinformowany:
- Drogą e-mail (na adres podany przy rejestracji)
- Poprzez komunikat wyświetlany po zalogowaniu do Serwisu

9.3 Niniejszy Regulamin w wersji 1.0 wchodzi w życie z dniem **${UPDATED}**. Kolejne zmiany Regulaminu wchodzą w życie z dniem opublikowania lub w terminie wskazanym w powiadomieniu. Jeżeli użytkownik nie akceptuje zmian, może usunąć konto przed wejściem zmian w życie.

Data ostatniej aktualizacji: **${UPDATED}**`,
  },
  {
    id: 'prawo',
    title: '10. Postanowienia końcowe',
    content: `10.1 Prawem właściwym dla Regulaminu jest prawo polskie.

10.2 Spory wynikające z korzystania z Serwisu strony będą starać się rozwiązać polubownie. W razie braku porozumienia, spory rozstrzygane będą przez sąd powszechny właściwy dla siedziby Operatora.

10.3 Konsumenci mają prawo do skorzystania z pozasądowych metod rozstrzygania sporów, w tym platformy ODR dostępnej pod adresem: ec.europa.eu/consumers/odr.

10.4 Jeśli jakikolwiek przepis Regulaminu okazałby się nieskuteczny lub nieważny, pozostałe przepisy zachowują moc wiążącą.

10.5 W sprawach nieuregulowanych Regulaminem stosuje się przepisy Kodeksu cywilnego oraz ustawy o świadczeniu usług drogą elektroniczną.`,
  },
];

const SECTIONS_EN = [
  {
    id: 'ogolne',
    title: '1. General provisions',
    content: `1.1 These Terms of Service govern the rules for using the Gap Assessment by MQS website available at gapassessment.pl ("Service").

1.2 The Service is operated by MQS MARCIN RABIASZ (Tax ID / NIP: 8971742369, REGON: 540955465, ul. Hiacyntow 5, 41-600 Swietochlowice, Silesia, Poland), registered as a sole trader in the Polish Central Register of Business Activity (CEIDG) ("Operator"), reachable at kontakt@mqs.com.pl.

1.3 Using the Service constitutes acceptance of these Terms. If you do not agree with these Terms, please stop using the Service.

1.4 These Terms are available at gapassessment.pl/regulamin in a format that can be downloaded, saved and printed.`,
  },
  {
    id: 'uslugi',
    title: '2. Description of services',
    content: `2.1 Gap Assessment by MQS is a tool that supports ISO consultants and auditors managing a portfolio of clients, using artificial intelligence. The Service offers in particular:

- **Gap Audit** - analysis of a client's document against a chosen standard or regulation (including ISO 9001, 14001, 45001, 27001, 22301, IATF 16949, VDA 6.3, ISO/IEC 42001, AQAP 2110/2210/2131, NIS2/UKSC 2026, GDP), with a percentage compliance score and a list of specific findings
- **AI-proposed fixes** - the AI proposes specific fix text for each finding; once accepted (individually or in batch mode), the fix is written directly into the .docx file
- **Score safeguard** - a warning before accepting a fix that would lower a previously reached compliance score, with the option to undo the change
- **Client portfolio** - a single portal to manage multiple separate client spaces, each with its own analysis and document history
- **Team and roles** - inviting collaborators with the Owner, Auditor or Approver role, with an optional restriction to a single client space
- **Public report link** - a secure, time-limited link allowing an approved analysis result to be shared without requiring login
- **White-label** - the ability to customise the look of reports to the consultant's own brand

2.2 **Important disclaimer:** The Service is a supporting tool, not a certification advisor. Analysis results and proposed fixes:
- Are a starting point for further verification by the user
- Are not a substitute for a certification consultant or auditor
- Require evaluation and adaptation to the specifics of the client's organisation
- Do not guarantee obtaining ISO certification or compliance with regulatory requirements (UKSC 2026, NIS2, etc.)

2.3 The Operator provides services 24/7, but does not guarantee uninterrupted service availability. Planned technical maintenance will be communicated in advance.`,
  },
  {
    id: 'konto',
    title: '3. User account',
    content: `3.1 Using the Service requires creating an account (as the owner of a new company) or joining an existing account by invitation from its owner. A valid email address and password are required for registration.

3.2 The user is obliged to:
- Provide accurate data during registration
- Keep the account password confidential
- Notify the Operator immediately of any unauthorised access to the account

3.3 Accounts may not be resold. Team collaboration works through the invitation and role mechanism described in section 2.1, not by sharing one user's login credentials.

3.4 The default retention period for Gap Audit results and the content of uploaded source files is **24 months** from the analysis date. The account owner may shorten or extend this period in Account Settings. After the configured period expires, documents are automatically and permanently deleted. Users may delete client documents at any time in the History tab, regardless of the configured retention period.

3.5 The user may delete their account at any time by contacting the Operator at kontakt@mqs.com.pl. Account deletion results in immediate and permanent deletion of all documents and account data from the database.

3.6 The Operator reserves the right to suspend or delete an account of a user who violates these Terms.`,
  },
  {
    id: 'zasady',
    title: '4. Rules of use',
    content: `4.1 The user agrees to use the Service in accordance with applicable law, these Terms and good practices.

4.2 Prohibited activities include:
- Using the Service for unlawful purposes
- Attempting to circumvent technical security measures, including attempts to influence the AI model's behaviour through the content of uploaded documents ("prompt injection")
- Automated data collection (scraping) without the Operator's consent
- Reselling account access or sharing it with people outside the invited team
- Using the Service in a way that excessively burdens the infrastructure (e.g. mass automated uploads)
- Uploading documents containing data for which the user does not have their own legal basis for processing (see Privacy Policy, section 7.4)

4.3 Uploaded documents and contextual data entered in the Service (client name, industry) should be truthful and must not infringe third-party rights.

4.4 Analysis results and generated fixes are intended exclusively for the user's own use or that of the client they concern.`,
  },
  {
    id: 'wlasnosc',
    title: '5. Intellectual property rights',
    content: `5.1 **Rights to the Service:** All rights to the Service, including the interface, logo, source code and graphics, belong to the Operator or are used under licence. Copying or developing the Service is prohibited.

5.2 **Rights to analysis results and fixes:** Gap Audit results and the content of fixes accepted by the user, produced from a document uploaded by the user, are the property of the user. The Operator does not acquire any rights to this content.

5.3 **Feedback and suggestions:** Any suggestions submitted by users regarding the development of the Service may be freely implemented by the Operator without any mutual obligations.`,
  },
  {
    id: 'platnosci',
    title: '6. Payments and terms of cooperation',
    content: `6.1 A Trial account can be created self-service on the Service website, without providing payment card details. The Trial account covers a limited scope: up to 3 clients in the portfolio, up to 10 Gap Audit analyses, and access to all standards available in the Service, with no time limit on use.

6.2 Current pricing for paid plans (Starter, Growth, Enterprise) is publicly available at gapassessment.pl/cennik. Starter and Growth plans are activated self-service at gapassessment.pl/cennik via online payment processed by PayU S.A. (ul. Grunwaldzka 186, 60-166 Poznan, Poland, KRS 0000274399) - a national payment institution supervised by the Polish Financial Supervision Authority. The Operator does not store payment card details or online banking credentials - these are processed exclusively by PayU.

6.3 The Enterprise plan is priced individually, depending on the client's scale and integration requirements, following a conversation with the Operator, and is not available for self-service online purchase.

6.4 **Order fulfilment.** Starter and Growth plans activate automatically and immediately upon payment confirmation by PayU (typically within a few minutes, in exceptional cases up to 1 business day if payment confirmation is delayed). Payment is one-time and covers a 1-month period - the Service does not currently charge recurring payments automatically; extending the plan for a further period requires a new, self-service payment, and the user is notified by email 7 days before the paid period expires. Failure to renew results in the account automatically reverting to the free Trial plan and its limits, without loss of portfolio data. Because access to the digital service is activated automatically and immediately, before making payment the user gives separate, explicit consent to the commencement of service performance before expiry of the 14-day withdrawal period referred to in the Polish Consumer Rights Act - under Article 38(13) of that Act, the right of withdrawal does not apply in such a case.

6.5 **Returns and complaints.** Complaints regarding payments or the operation of a paid plan should be reported to kontakt@mqs.com.pl, stating the email address used for account registration and a description of the issue. Complaints are handled within 14 business days. In the case of an incorrectly charged or duplicate payment, the Operator will refund the amount due to the account from which payment was made, within 14 days of the complaint being deemed valid.

6.6 For questions about pricing and payments, contact kontakt@mqs.com.pl.`,
  },
  {
    id: 'odpowiedzialnosc',
    title: '7. Limitation of liability',
    content: `7.1 The Operator makes every effort to ensure that analysis results and AI-proposed fixes are as accurate as possible, however:

**7.2 The Operator is not liable for:**
- Results of a client's certification audit based on analyses or fixes from the Service
- Business or operational decisions made on the basis of Service results
- Non-compliance of results with the specific requirements of the user's clients
- Changes to standards introduced after the analysis date
- Incorrect or incomplete documents uploaded by the user
- Service interruptions caused by external factors (network failures, force majeure)

7.3 The Operator's liability is limited to the amount of fees paid by the user in the last 12 months.

7.4 Analysis results and proposed fixes are a supporting working tool - the Service deliberately warns before accepting a change that would lower the compliance score (section 2.1), but the final evaluation and the decision to implement any fix rests with the user.`,
  },
  {
    id: 'dane',
    title: '8. Personal data processing',
    content: `8.1 The rules for processing personal data are described in the Privacy Policy available at gapassessment.pl/polityka-prywatnosci.

8.2 By accepting these Terms, the user confirms that they have read the Privacy Policy.`,
  },
  {
    id: 'zmiany',
    title: '9. Changes to these Terms',
    content: `9.1 The Operator reserves the right to change these Terms for important reasons, such as:
- Changes in law affecting the services provided
- Introduction of new features or a payment model
- Organisational or technical changes

9.2 Users will be notified of changes to the Terms:
- By email (to the address provided during registration)
- Via a notice displayed after logging into the Service

9.3 These Terms version 1.0 enter into force on **${UPDATED}**. Subsequent changes enter into force on the date of publication or on the date indicated in the notice. If the user does not accept the changes, they may delete their account before the changes take effect.

Date of last update: **${UPDATED}**`,
  },
  {
    id: 'prawo',
    title: '10. Final provisions',
    content: `10.1 Polish law governs these Terms.

10.2 Disputes arising from the use of the Service will be resolved amicably by the parties. If no agreement is reached, disputes will be settled by the court with jurisdiction over the Operator's registered address.

10.3 Consumers have the right to use out-of-court dispute resolution methods, including the ODR platform available at: ec.europa.eu/consumers/odr.

10.4 If any provision of these Terms proves to be ineffective or invalid, the remaining provisions remain binding.

10.5 Matters not regulated by these Terms are governed by the Polish Civil Code and the Act on the provision of electronic services.`,
  },
];

function renderContent(text) {
  const lines = text.split('\n');
  const result = [];

  lines.forEach((line, i) => {
    if (!line.trim()) {
      result.push(<div key={i} style={{ height: 6 }} />);
    } else if (line.startsWith('- **')) {
      const match = line.match(/^- \*\*([^*]+)\*\*(.*)/);
      if (match) {
        result.push(
          <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 6, paddingLeft: 12 }}>
            <span style={{ color: 'var(--accent)', flexShrink: 0, marginTop: 2 }}>•</span>
            <p style={{ color: 'var(--ink-soft)', margin: 0, fontSize: '0.88rem', lineHeight: 1.65 }}>
              <strong style={{ color: 'var(--ink)' }}>{match[1]}</strong>{match[2]}
            </p>
          </div>
        );
      }
    } else if (line.startsWith('- ')) {
      result.push(
        <div key={i} style={{ display: 'flex', gap: 10, marginBottom: 6, paddingLeft: 12 }}>
          <span style={{ color: 'var(--ink-soft)', flexShrink: 0, marginTop: 2 }}>•</span>
          <p style={{ color: 'var(--ink-soft)', margin: 0, fontSize: '0.88rem', lineHeight: 1.65 }}>{renderInline(line.slice(2))}</p>
        </div>
      );
    } else if (/^\*\*[^*]+\*\*$/.test(line.trim())) {
      result.push(<p key={i} style={{ fontWeight: 700, color: 'var(--ink)', margin: '14px 0 6px', fontSize: '0.92rem' }}>{line.trim().slice(2, -2)}</p>);
    } else {
      result.push(<p key={i} style={{ color: 'var(--ink-soft)', margin: '0 0 8px', lineHeight: 1.7, fontSize: '0.88rem' }}>{renderInline(line)}</p>);
    }
  });

  return result;
}

function renderInline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    /^\*\*[^*]+\*\*$/.test(p)
      ? <strong key={i} style={{ color: 'var(--ink)', fontWeight: 700 }}>{p.slice(2, -2)}</strong>
      : p
  );
}

export default function TermsPage() {
  const navigate = useNavigate();
  const { lang } = useLang();

  const sections = lang === 'en' ? SECTIONS_EN : SECTIONS;

  return (
    <div className="legalp" style={{ minHeight: '100vh', background: 'var(--paper)', color: 'var(--ink)', fontFamily: "'Inter','Inter Fallback','Segoe UI',sans-serif" }}>
      <style>{LEGAL_TOKENS}</style>
      <nav style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'var(--paper-raised)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid var(--line-soft)',
        padding: '0 max(1.5rem, calc((100vw - 1100px)/2))',
        display: 'flex', alignItems: 'center', gap: 16, height: 60,
      }}>
        <a href="/" onClick={ev => { ev.preventDefault(); navigate('/'); }} style={{ background: 'none', border: 'none', color: 'var(--ink-soft)', cursor: 'pointer', fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: 6, padding: 0, textDecoration: 'none' }}>
          {lang === 'en' ? '← Home' : '← Strona główna'}
        </a>
        <span style={{ color: 'var(--line-soft)' }}>|</span>
        <span style={{ fontSize: '1rem', fontWeight: 800, color: 'var(--ink)' }}>Gap Assessment <span style={{ color: 'var(--accent)' }}>by MQS</span></span>
        <PublicToggleBar style={{ marginLeft: 'auto' }} />
      </nav>

      <main style={{ padding: '48px 1.5rem 80px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
          <span style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--accent)', letterSpacing: 2, textTransform: 'uppercase' }}>{lang === 'en' ? 'Legal documents' : 'Dokumenty prawne'}</span>
        </div>
        <h1 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.4rem)', fontWeight: 800, color: 'var(--ink)', marginBottom: 10, lineHeight: 1.1 }}>
          {lang === 'en' ? 'Terms of Service' : 'Regulamin Serwisu'}
        </h1>
        <p style={{ color: 'var(--ink-soft)', fontSize: '0.85rem', marginBottom: 48 }}>
          {lang === 'en' ? `Last updated: ${UPDATED} - Version 1.0` : `Ostatnia aktualizacja: ${UPDATED} - Wersja 1.0`}
        </p>

        <style>{`
          .tp-layout { display: grid; grid-template-columns: 240px 1fr; gap: 48px; align-items: start; }
          .tp-nav { position: sticky; display: block; }
          @media (max-width: 767px) {
            .tp-layout { grid-template-columns: minmax(0, 1fr) !important; gap: 0 !important; }
            .tp-nav { display: none !important; }
          }
        `}</style>
        <div className="tp-layout">
          <nav className="tp-nav" style={{ top: 80 }}>
            <p style={{ fontSize: '0.7rem', fontWeight: 700, color: 'var(--line)', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 12 }}>{lang === 'en' ? 'Table of contents' : 'Spis treści'}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {sections.map(s => (
                <a key={s.id} href={`#${s.id}`} style={{ fontSize: '0.8rem', color: 'var(--ink-soft)', textDecoration: 'none', padding: '5px 10px', borderRadius: 6, transition: 'all 0.15s', display: 'block', lineHeight: 1.4 }}
                  onMouseEnter={ev => { ev.target.style.color = 'var(--ink)'; ev.target.style.background = 'var(--line-soft)'; }}
                  onMouseLeave={ev => { ev.target.style.color = 'var(--ink-soft)'; ev.target.style.background = 'transparent'; }}>
                  {s.title}
                </a>
              ))}
            </div>
            <div style={{ marginTop: 28, padding: '16px', background: 'var(--accent-soft)', border: '1px solid var(--accent)', borderRadius: 10 }}>
              <p style={{ fontSize: '0.75rem', color: 'var(--accent)', fontWeight: 700, marginBottom: 6 }}>{lang === 'en' ? 'Questions?' : 'Masz pytania?'}</p>
              <p style={{ fontSize: '0.75rem', color: 'var(--ink-soft)', margin: 0, lineHeight: 1.5 }}>kontakt@mqs.com.pl</p>
            </div>
          </nav>

          <div>
            <div style={{ background: 'var(--amber-soft)', border: '1px solid var(--amber)', borderRadius: 12, padding: '16px 20px', marginBottom: 36 }}>
              <p style={{ fontSize: '0.85rem', color: 'var(--amber)', fontWeight: 600, marginBottom: 4 }}>{lang === 'en' ? 'Important disclaimer' : 'Ważne zastrzeżenie'}</p>
              <p style={{ fontSize: '0.82rem', color: 'var(--ink-soft)', lineHeight: 1.65, margin: 0 }}>
                {lang === 'en'
                  ? <span>Gap Assessment by MQS is an AI tool that supports ISO gap analysis - <strong style={{ color: 'var(--ink-soft)' }}>it is not a certification advisor</strong>. Analysis results and proposed fixes require verification and adaptation by the user. Use the Service as a starting point, not a ready-made solution for certification.</span>
                  : <span>Gap Assessment by MQS jest narzędziem AI wspomagającym analizę luk ISO - <strong style={{ color: 'var(--ink-soft)' }}>nie jest doradcą certyfikacyjnym</strong>. Wyniki analizy i proponowane poprawki wymagają weryfikacji i dostosowania przez użytkownika. Używaj Serwisu jako punktu wyjścia, a nie gotowego rozwiązania do certyfikacji.</span>}
              </p>
            </div>

            {sections.map(s => (
              <section key={s.id} id={s.id} style={{ marginBottom: 48, scrollMarginTop: 80 }}>
                <h2 style={{ fontSize: '1.1rem', fontWeight: 800, color: 'var(--ink)', marginBottom: 16, paddingBottom: 10, borderBottom: '1px solid var(--line-soft)' }}>{s.title}</h2>
                <div>{renderContent(s.content)}</div>
              </section>
            ))}
          </div>
        </div>
      </main>

      <footer style={{ borderTop: '1px solid var(--line-soft)', padding: '20px max(1.5rem, calc((100vw - 1100px)/2))', display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ fontSize: '0.85rem', fontWeight: 800, color: 'var(--ink)' }}>Gap Assessment <span style={{ color: 'var(--accent)' }}>by MQS</span></span>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <a href="/polityka-prywatnosci" style={{ fontSize: '0.78rem', color: 'var(--ink-soft)', textDecoration: 'none' }}>{lang === 'en' ? 'Privacy Policy' : 'Polityka prywatnosci'}</a>
          <a href="/regulamin" style={{ fontSize: '0.78rem', color: 'var(--accent)', textDecoration: 'none' }}>{lang === 'en' ? 'Terms of Service' : 'Regulamin'}</a>
          <a href="/" style={{ fontSize: '0.78rem', color: 'var(--ink-soft)', textDecoration: 'none' }}>{lang === 'en' ? 'Home' : 'Strona glowna'}</a>
        </div>
      </footer>
      <PrerenderReady />
    </div>
  );
}
